import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import PackageDetails from "./pages/PackageDetails";
import Cart from "./pages/Cart";
import styles from "./App.module.css";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className={styles.app}>
          <Navbar />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/package/:packageId" element={<PackageDetails />} />
            <Route path="/cart" element={<Cart />} />
          </Routes>

          <Footer />
          <WhatsAppFloat />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
